declare namespace $ {

	type $rise_radio__options_rise_radio_demo_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $rise_radio['options'] >
	>
	export class $rise_radio_demo extends $mol_example_small {
		Radio( ): $rise_radio
		sub( ): readonly(any)[]
		tags( ): readonly(any)[]
		aspects( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=demo.view.tree.d.ts.map